import axios from "@/config/axios"

const initiateState = () => {
  return {
    allEMRInsurances: {},
    updateEMRInsurance: false,
    removeEMRInsurance: false,
  }
}
const state = initiateState()
const getters = {
  getEMRInsurances: (state) => state.allEMRInsurances,
  getUpdateEMRInsuranceStatus: (state) => state.updateEMRInsurance,
  getRemoveEMRInsuranceStatus: (state) => state.removeEMRInsurance,
}
const mutations = {
  setEMRInsurances(state, data) {
    state.allEMRInsurances = data
  },
  setUpdateEMRInsurance(state, data) {
    state.updateEMRInsurance = data
  },
  setRemoveEMRInsurance(state, data) {
    state.removeEMRInsurance = data
  },
  reset: (state) => {
    const initial = initiateState()
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key]
    })
  },
}
const actions = {
  fetchEMRInsurances: async ({ commit, dispatch }, params) => {
    try {
      await dispatch("errors/clear", [], { root: true })
      const response = await axios.get("insurance-not-mapped", { params })
      commit("setEMRInsurances", response.data)
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true })
      }
    }
  },
  updateEMRInsurance: async ({ commit, dispatch }, { id, data }) => {
    try {
      await dispatch("errors/clear", [], { root: true })
      commit("setUpdateEMRInsurance", false)
      await axios.patch(`insurance-not-mapped/${id}`, data)
      commit("setUpdateEMRInsurance", true)
    } catch (error) {
      commit("setUpdateEMRInsurance", false)
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true })
      }
    }
  },
  removeEMRInsurance: async ({ commit, dispatch }, id) => {
    try {
      await dispatch("errors/clear", [], { root: true })
      commit("setRemoveEMRInsurance", false)
      await axios.delete(`insurance-not-mapped/${id}`)
      commit("setRemoveEMRInsurance", true)
    } catch (error) {
      commit("setRemoveEMRInsurance", false)
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true })
      }
    }
  },
}
export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
}
